import { BonusHelpLandscapeProperties } from "../landscape/BonusHelpLandscapeProperties";
export class BonusHelpPortraitProperties extends BonusHelpLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.position.set(857, 65);
    }
}
